import { useState, useEffect } from "react"
import axios from "axios"
import "./PublicLessonsReservation.css"
import Cookie from "js-cookie"

import { FaX } from "react-icons/fa6";
import {
  format,
  startOfWeek,
  addDays,
  isSameDay,
  parseISO,
  addWeeks,
  subWeeks
} from "date-fns"
import csLocale from "date-fns/locale/cs"
import { useParams } from "react-router-dom"

const IframeLessonsReservation = () => {
    const [message, setMessage] = useState({});
    const businessId = useParams()
    const [quest, setQuest] = useState({
        name: "",
        phone:"",
        email:"",
    })
    const [showForm, setShowForm] = useState(false)
    const [actualLessons, setActualLessons] = useState("")
    const [detailOverlay, setDetailOverlay] = useState(false)
    const [selectedLesson, setSelectedLesson] = useState(null)
  const [lessonInstances, setLessonInstances] = useState([])
  const [currentWeekStart, setCurrentWeekStart] = useState(startOfWeek(new Date(), { weekStartsOn: 1 }))
    const [sending, setSending] = useState(false)
  const [selectedLessonName, setSelectedLessonName] = useState("")



    useEffect(() => {
        const savedCookie = Cookie.get("quest")
        if (savedCookie) {
            try {
                setQuest(JSON.parse(savedCookie));
            } catch (err) {
                console.error("Chyba při parsování cookie:", err);
            }
        }
    }, [])

  useEffect(() => {
    const fetchLessons = async () => {
        
      try {
        const res = await axios.get(`${process.env.REACT_APP_API_URL}/lessons/get-instances`, {
          params: { businessId: businessId.businessId }
        })
        setLessonInstances(res.data)

      } catch (err) {
        console.error("Chyba při načítání lekcí:", err)
      }
    }

    if (businessId) fetchLessons()

  }, [businessId])

  const fetchNewLessons = async () => {
        
    try {
      const res = await axios.get(`${process.env.REACT_APP_API_URL}/lessons/get-instances`, {
        params: { businessId: businessId.businessId }
      })
      setLessonInstances(res.data)
    } catch (err) {
      console.error("Chyba při načítání lekcí:", err)
    }
  }

  const getWeekDays = () => {
    return [...Array(7)].map((_, i) => addDays(currentWeekStart, i))
  }

  const handlePrevWeek = () => {
    setCurrentWeekStart((prev) => subWeeks(prev, 1))
  }

  const handleNextWeek = () => {
    setCurrentWeekStart((prev) => addWeeks(prev, 1))
  }

  const openDetailOverlay = (lesson) => {

    setSelectedLesson(lesson)
    setDetailOverlay(true)
  }
  const closeDetailOverlay = () => {
    setDetailOverlay(false)
    setSelectedLesson(null)
  }

  const availablePosition = (users, capacity) => {
    if (!capacity) return "Nezadáno"
    return capacity - users.length
  }

  const handleChange = (e) => {
    const {name, value} = e.target

    setQuest((prev) => ({
        ...prev,
        [name]: value,
    }))
  }
  const handleSubmit = async (id) => {

    if (quest.name) {
      const userData = quest
      setShowForm(false)
      try {
        setSending((prev) => ({
            ...prev,
            [id]: true,
          }))
        const response = await axios.post(`${process.env.REACT_APP_API_URL}/lessons/invite`, {
          userData,
          id
        })
        setMessage(prev => ({
          ...prev,
          [id]: response.data.message || "Odesláno"
        }))
      } catch (err) {
        setMessage(prev => ({
          ...prev,
          [id]: err.response?.data?.message || "Chyba při odeslání"
        }))
      } finally {
        Cookie.set("quest", JSON.stringify(quest), {expires: 365})
        setSending((prev) => ({
            ...prev,
            [id]: false,
          }))
        setTimeout(() => {
          setMessage({})
        }, 2000)
        setTimeout(() => {
          fetchNewLessons()
        }, 3000)
      }
    } else {
        setShowForm(true)
        setActualLessons(id)
    }
  }




  return (
      <div className="calendar-conteiner">
        <h2 className="services-title">Skupinové aktivity</h2>
  <div className="calendar-header">
  <div className="lesson-buttons-header">
    <button className="lesson-button" onClick={handlePrevWeek}>Předchozí týden</button>
    <span className="calendar-week-range visible-range">
      {format(currentWeekStart, "dd.MM.yyyy")} – {format(addDays(currentWeekStart, 6), "dd.MM.yyyy")}
    </span>
    <button className="lesson-button" onClick={handleNextWeek}>Následující týden</button>
  </div>
  <span className="calendar-week-range non-visible-range">
      {format(currentWeekStart, "dd.MM.yyyy")} – {format(addDays(currentWeekStart, 6), "dd.MM.yyyy")}
    </span>
  
  </div>
  <div>
    <select
      className='basic-input reservation-select lesson-select'
      value={selectedLessonName}
      onChange={(e) => setSelectedLessonName(e.target.value)}
    >
      <option value="">Všechny lekce</option>
      {[...new Set(lessonInstances.map((lesson) => lesson.template?.name))]
        .filter(Boolean)
        .sort()
        .map((name) => (
          <option key={name} value={name}>
            {name}
          </option>
        ))}
    </select>
  </div>
  <div className='forwarding'>
            <p>Pokračujete jako {quest.name}</p>
        </div>
  
        <div className="calendar">
          {getWeekDays().map((day) => {
            const lessonsForDay = lessonInstances.filter((lesson) =>
              isSameDay(parseISO(lesson.date), day) && 
            (selectedLessonName === "" || lesson.template?.name === selectedLessonName)
            )
  
  
  
  
            return (
              <div key={day.toISOString()}>
              <div className="calendar-day">
                <h3>{format(day, "EEEE dd.MM", { locale: csLocale })}</h3>
                {lessonsForDay.length > 0 ? (
                  lessonsForDay.map((lesson) => (
                    <div key={lesson?._id} className={`lesson ${lesson.status === "open" ? "open-lesson" : "not-open-lesson"}`}>
                      <h2>{lesson.template?.name}</h2>
                      <div className="lesson-calendar-span"><h5>Zahájení:</h5><p> {lesson?.time}</p></div>
                      <div className="lesson-calendar-span"><h5>Volná místa:</h5><p>  {availablePosition(lesson.users, lesson.template?.capacity)}</p></div>
                      <div className="lesson-calendar-span"><h5>Cena:</h5><p>  {lesson.template?.cost} Kč</p></div>
                      {lesson.users?.length >= lesson.template?.capacity ? (<div className="lesson-center-buttons">
                        <h2>Plně obsazeno</h2>
                      </div>) : (<div>
                        {!message[lesson._id] && <div className="lesson-center-buttons">
                        <button className="lesson-button"  onClick={() => handleSubmit(lesson._id)}>{sending[lesson?._id] ? "Přidávám..." : "Zúčastnit se"}</button>
                        <button className="lesson-button"  onClick={() => openDetailOverlay(lesson)}>Detail</button>
                        </div>}
                      </div>)}
                      {message[lesson._id] && <p className="message">{message[lesson._id]}</p>}
                    </div>
                  ))
                ) : (
                  <div></div>
                )}
              </div>
            </div>)
          })}
        </div>
        {detailOverlay && selectedLesson && (
    <div className="lesson-overlay">
      <div className="lesson-overlay-content">
        <button onClick={closeDetailOverlay} className="lesson-close-button"><FaX /></button>
        <h2 className="lesson-calendar-name-overlay">{selectedLesson?.template?.name}</h2>
        <div className="lesson-calendar-span-overlay"><h5>Instruktor:</h5><p>{selectedLesson?.otherInstructor || selectedLesson.template?.instructor}</p></div>
        <div className="lesson-calendar-span-overlay"><h5>Datum:</h5><p> {format(parseISO(selectedLesson?.date), "dd.MM.yyyy", { locale: csLocale })}</p></div>
        <div className="lesson-calendar-span-overlay"><h5>Zahájení:</h5><p> {selectedLesson?.time}</p></div>
        <div className="lesson-calendar-span-overlay"><h5>Kapacita:</h5><p> {selectedLesson?.template?.capacity}</p></div>
        <div className="lesson-calendar-span-overlay"><h5>Volná místa:</h5><p> {availablePosition(selectedLesson.users, selectedLesson.template?.capacity)}</p></div>
        <div className="lesson-calendar-span-overlay"><h5>Cena:</h5><p> {selectedLesson?.template?.cost} Kč</p></div>
        <div className="lesson-calendar-span-overlay"><h5>Trvání lekce:</h5><p> {selectedLesson?.template?.duration} minut</p></div>
        <div className="lesson-center-buttons lesson-margin-top">
          <button className="lesson-button " onClick={() => handleSubmit(selectedLesson?._id)}>{sending ? "Přidávám..." : "Zúčastnit se"}</button>
        </div>
        {selectedLesson?._id && message[selectedLesson._id] && (
          <p className="message">{message[selectedLesson._id]}</p>
        )}
        {/* můžeš přidat další informace */}
      </div>
    </div>
  )}
        { showForm && <div className="lesson-overlay">
            
            <form onSubmit={() => handleSubmit(actualLessons)}>
            <input
                type="text"
                name="name"
                value={quest.name}
                onChange={handleChange}
                placeholder="Jméno a přijmení"
                className="login-input"
                required
            />
            <input
                type="phone"
                name="phone"
                value={quest.phone}
                onChange={handleChange}
                className="login-input"
                placeholder="Telefon"
                required
            />
            <input
                type="email"
                name="email"
                value={quest.email}
                onChange={handleChange}
                className="login-input"
                placeholder="Email"
                required
            />
            <div className="lesson-center-buttons lesson-margin-top">
            <button type="submit" className="lesson-button">Potvrdit</button>
            </div>
            </form>
           

        </div>}
        <div className='business-container'>
        <div className='powered'><p>powered by </p><a href="https://resanio.com" target="_blank" rel="noopener noreferrer">
            RESANIO.com
        </a></div>

        </div>

      </div>
    )
}

export default IframeLessonsReservation